import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { EnvironmentInjector } from '@next/core-lib/environment';
import { Environment } from 'src/environment';

import { Application, ApplicationGroup, Datastream, SingleApplicationDatastream } from '../models';

@Injectable({
  providedIn: 'root',
})
export class ApiService {
  protected http = inject(HttpClient);
  private readonly env = inject<Environment>(EnvironmentInjector);

  private readonly baseUrl = this.env.API_BASE_URL + '/service/authorization/secure/';

  getApplications() {
    return this.http.get<Application[]>(this.baseUrl + 'access/application');
  }

  getApplicationGroups() {
    return this.http.get<ApplicationGroup[]>(this.baseUrl + 'access/application-group/Partner');
  }

  getDatastreams() {
    return this.http.get<Datastream[]>(this.baseUrl + 'access/datastream');
  }

  getApplicationDatastreams(entityExternalId: string, system: string) {
    return this.http.get<SingleApplicationDatastream[]>(
      this.baseUrl + 'access/applicationdatastream',
      {
        params: {
          EntityExternalId: entityExternalId,

          System: system,
        },
      },
    );
  }

  setApplicationDatastream(
    applicationKey: string,
    datastreamKey: string,
    entityExternalId: string,
    system: string,
  ) {
    return this.http.post(this.baseUrl + 'access/applicationdatastream', {
      applicationKey,
      datastreamKey,
      entityExternalId,
      system,
    });
  }

  deleteApplicationDatastream(
    applicationKey: string,
    datastreamKey: string,
    entityExternalId: string,
    system: string,
  ) {
    return this.http.request('DELETE', this.baseUrl + 'access/applicationdatastream', {
      body: { applicationKey, datastreamKey, entityExternalId, system },
    });
  }
}
